module.exports = {
	"es": {
		"conversation": {
			"widget": {
				"title": "Chatea con nosotros"
			}
		}
	}
};